import React from 'react'

const Catalog = () => {
  return (    
  
<div className="container-fluid p-4">

  <div className="container border p-4 rounded d-flex flex-column align-items-center">
    

    <div className="container border p-4 rounded d-flex flex-column align-items-center gap-3">
      <h1 className="text-muted"><i className="bi bi-shop-window"></i></h1>

      <button className="btn btn-success">Upload Catalog</button>

      <h6 className="text-muted">OR</h6>

      <button className="btn border border-success text-success bg-white">
  Set up a FB Catalog
</button>
    </div>

  </div>
</div>

  )
}

export default Catalog